import { useEffect } from 'react';

import { fabric } from 'fabric';

import { ANNOTATION_COLORS, ANNOTATION_STROKES } from '~/contexts/CanvasContext';

import { IUseFabric } from './types';

export const useDrawAnnotation = (props: IUseFabric & { zoomed?: boolean; }) => {
  const { ref, context, zoomed } = props;
  const { annotationEnabled, mode, color, stroke, zoom } = context;
  const width = ANNOTATION_STROKES[stroke] / (zoomed ? zoom : 1);
  useEffect(() => {
    const canvas = ref.current;
    if (annotationEnabled && mode === 'draw') {
      const brush = new fabric.PencilBrush(canvas);
      brush.color = ANNOTATION_COLORS[color];
      brush.width = width;
      canvas.freeDrawingBrush = brush;
      canvas.isDrawingMode = true;
    }
    return () => {
      canvas.isDrawingMode = false;
    }
  }, [annotationEnabled, color, mode, ref, width]);
}
